import React from 'react';
import { PropTypes } from 'prop-types';
import { Row, FormElements, Grid, Spinner } from '@custom-components';
import { StyledInfoContainer, StyledContainer } from '../Steps.styles';

function ConnectionProvider(props) {
  const { mainForm, data, loading, handleChangeOption } = props;

  const loadProviderOptions = (defaultOption, connectionTypeId) =>
    defaultOption.filter((item) => item.connectionTypeId === connectionTypeId);

  return (
    <div style={{ marginTop: '5%' }}>
      {loading ? (
        <div style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
          <Spinner size={22} />
        </div>
      ) : (
        <StyledInfoContainer>
          <StyledContainer>
            <Row>
              <Grid.Col lg={12}>
                <FormElements.Select
                  variant="outlined"
                  id="connectionProvider"
                  key="connectionProvider"
                  name="connectionProvider"
                  label="Select Connection Provider"
                  value={mainForm.values.connectionProvider}
                  options={loadProviderOptions(data, mainForm.values.id.connectionType)}
                  onBlur={mainForm.handleBlur}
                  onChange={(item) => handleChangeOption(mainForm, item, data)}
                  error={!!mainForm.errors.connectionProvider}
                  errorText={mainForm.errors.connectionProvider}
                  inputProps={{ readOnly: true }}
                />
              </Grid.Col>
            </Row>
          </StyledContainer>
        </StyledInfoContainer>
      )}
    </div>
  );
}

ConnectionProvider.propTypes = {
  mainForm: PropTypes.shape({
    values: {
      connectionProvider: PropTypes.string
    },
    errors: {
      connectionProvider: PropTypes.string
    },
    handleBlur: PropTypes.func
  }),
  data: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  error: PropTypes.shape({}),
  handleChangeOption: PropTypes.func
};

ConnectionProvider.defaultProps = {
  mainForm: {},
  data: [],
  loading: false,
  error: {},
  handleChangeOption: () => {}
};

export default ConnectionProvider;
